import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TourAcceptService {
  private apiUrl = `${environment.baseUrl}users/`;
  
  constructor(private http: HttpClient) { }

  tourAccept(data: any): Observable<any> {
    return this.http.post(`${environment.baseUrl}users/verify/confirm`, data);
  }

  isTourAccepted(data: any): Observable<any> {
    return this.http.post(`${environment.baseUrl}users/accepted`, data);
  }

  getTour(_id: string): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}tours/${_id}`);
  }

  getUser(_id: string): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}users/${_id}`);
  }
}
